import { ref } from 'vue'

// Global state (singleton pattern)
const isDark = ref(false)
let isInitialized = false

const updateTheme = () => {
  console.log('[useTheme] updateTheme called with isDark:', isDark.value)

  if (isDark.value) {
    document.documentElement.classList.add('dark')
    document.documentElement.setAttribute('data-theme', 'dark')
    localStorage.setItem('theme', 'dark')
    console.log('[useTheme] Applied dark theme')
  } else {
    document.documentElement.classList.remove('dark')
    document.documentElement.setAttribute('data-theme', 'light')
    localStorage.setItem('theme', 'light')
    console.log('[useTheme] Applied light theme')
  }

  // Dispatch custom event for components that need to react to theme changes
  window.dispatchEvent(
    new CustomEvent('theme-changed', {
      detail: { isDark: isDark.value },
    }),
  )
  console.log('[useTheme] Dispatched theme-changed event')
}

const initTheme = () => {
  if (isInitialized) return
  console.log('[useTheme] initTheme called')

  // Check for saved theme preference or system preference
  const savedTheme = localStorage.getItem('theme')
  const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

  console.log('[useTheme] savedTheme:', savedTheme, 'systemPrefersDark:', systemPrefersDark)

  // Set initial theme - for debugging, let's start with light mode
  if (savedTheme) {
    isDark.value = savedTheme === 'dark'
  } else {
    // For debugging purposes, start with light mode
    isDark.value = false
  }

  console.log('[useTheme] Initial isDark set to:', isDark.value)
  updateTheme()
  isInitialized = true

  // Listen for system theme changes
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  const handleSystemThemeChange = (e) => {
    // Only update if user hasn't manually set a preference
    if (!localStorage.getItem('theme')) {
      isDark.value = e.matches
    }
  }

  mediaQuery.addEventListener('change', handleSystemThemeChange)
}

const toggleTheme = () => {
  console.log('[useTheme] toggleTheme called. Current isDark:', isDark.value)
  isDark.value = !isDark.value
  console.log('[useTheme] isDark toggled to:', isDark.value)
  updateTheme()
}

// Initialize immediately if in browser environment
if (typeof window !== 'undefined') {
  initTheme()
}

export function useTheme() {
  // Ensure initialization
  if (typeof window !== 'undefined' && !isInitialized) {
    initTheme()
  }

  return {
    isDark,
    toggleTheme,
    initTheme,
    updateTheme,
  }
}
